// Mark award presence, not award counts. Draw outside the bars so usage values stay unchanged.
export function milestoneDotsPlugin (daily, levels) {
  return {
    id: 'milestoneDots',
    afterDatasetsDraw (chart) {
      const bars = chart.getDatasetMeta(0).data
      const ctx = chart.ctx
      ctx.save()
      bars.forEach((bar, index) => {
        const awarded = new Set(daily[index]?.milestone_levels || [])
        const radius = Math.min(3.5, Math.max(1, bar.width * 0.4))
        levels.filter(row => awarded.has(row.level)).forEach((row, position) => {
          ctx.beginPath()
          ctx.arc(bar.x, bar.y - 8 - position * 10, radius, 0, Math.PI * 2)
          ctx.fillStyle = row.color
          ctx.fill()
          ctx.strokeStyle = '#525252'
          ctx.lineWidth = 0.5
          ctx.stroke()
        })
      })
      ctx.restore()
    }
  }
}
